import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  BESelectedArrayStepOne: [],
  BESelectedArrayStepTwo: [], // Add this state for Step Two
  BEStepThree: { work: "", isVisibleManager: false, personalGrowth: "" },
  BEStepFour: { work: "", isVisibleManager: false, personalGrowth: "" },
  BEStepFive: { work: "", isVisibleManager: false, personalGrowth: "" },
  showComplition: false,
  stepNo: 0,
  visibleEditOption: false,
};

const strengthSlice = createSlice({
  name: "strength",
  initialState,
  reducers: {
    saveSelectedStrengthsStepOne(state, action) {
      state.BESelectedArrayStepOne = action.payload;
    },
    saveSelectedStrengthsStepTwo(state, action) {
      // Reducer for Step Two
      state.BESelectedArrayStepTwo = action.payload;
    },
    saveStepThree(state, action) {
      state.BEStepThree = action.payload;
    },
    saveStepFour(state, action) {
      state.BEStepFour = action.payload;
    },
    saveStepFive(state, action) {
      state.BEStepFive = action.payload;
    },
    saveStrengthComplition(state, action) {
      state.showComplition = action.payload;
    },
    saveStepNo(state, action) {
      state.stepNo = action.payload;
    },
    saveVisibleEditOption(state, action) {
      state.visibleEditOption = action.payload;
    },
  },
});

export const {
  saveSelectedStrengthsStepOne,
  saveSelectedStrengthsStepTwo,
  saveStepThree,
  saveStepFour,
  saveStepFive,
  saveStrengthComplition,
  saveStepNo,
  saveVisibleEditOption,
} = strengthSlice.actions;

export default strengthSlice.reducer;
